<ion-app>
  <!-- Main layout with sidebar for authenticated non-auth routes -->
  <ion-split-pane contentId="main-content" when="false" *ngIf="!isAuthRoute && isAuthenticated && !isHomePage">
    <ion-menu contentId="main-content">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <ion-title (click)="navigateTo('/')" style="cursor: pointer;">
            <div class="logo-container">
              <img src="assets/images/logo-light-theme.png" alt="WaddleNAV" class="logo-light" />
              <img src="assets/images/logo-dark-theme.png" alt="WaddleNAV" class="logo-dark" />
            </div>
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-menu-toggle [autoHide]="false" *ngFor="let p of appPages">
            <ion-item button [routerLink]="p.url" routerLinkActive="active-item" [routerLinkActiveOptions]="{exact: p.url === '/'}">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <div class="user-role">
          <div class="user-avatar" [class.has-image]="!!userAvatarUrl">
            <img *ngIf="userAvatarUrl" [src]="userAvatarUrl" alt="avatar" (error)="onAvatarError()" />
            <span *ngIf="!userAvatarUrl">{{ userInitial }}</span>
          </div>
          <ion-label>
            <span class="role-label">Name:</span>
            <span class="role-value">{{ userName || 'Unknown' }}</span>
          </ion-label>
          <div class="build-number">
            <ion-label>{{ displayVersion }}</ion-label>
          </div>
          <div class="feedback-action">
            <ion-button expand="block" size="small" (click)="openFeedback()">Send Feedback</ion-button>
          </div>
        </div>
      </ion-content>
    </ion-menu>

    <div class="ion-page" id="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>

  <!-- Auth layout or Home layout without sidebar -->
  <div class="full-layout" *ngIf="isAuthRoute || !isAuthenticated || isHomePage">
    <div [id]="isHomePage ? 'home-content' : ''" class="ion-page">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </div>
</ion-app>
